import React from "react"

import FieldTaskAssignedToUser from "../assigned-to-user"
import {FieldGoalListEditableProps} from "../../../../../render/goal-list/goal-list-editable"
import UserIcon from "../../../../../../gd-components/icons/user/user"

type Props = {
    field: FieldTaskAssignedToUser
} & FieldGoalListEditableProps

const debug = false
// const debug = "FieldTaskAssignedToUser_GoalListView"

export default function FieldTaskAssignedToUser_GoalListView(props:Props) {

    const value = _.get(props.model, props.field.fieldId, null)

    const user = gd.session.users.get(value)

    if (!user) return false

    const style = {
        minHeight   : 24,
        overflow    : 'hidden', //required for txt-truncate to work correctly
    }

    const companyUser = gd.session.companyUsers.getByUserId(user.id) || {isActivated:false}

    const nameClasses = Classes("txt-truncate", {
        "ui5-txt-less-important-small"  : companyUser.isActivated,
        "ui5-txt-not-important-small"   : !companyUser.isActivated
    })

    return (
        <div className={Classes('flex-row-left-center', props.className)} style={style}>
            <UserIcon className="m-r-5" userId={user.id} size="22"/>
            <div className={nameClasses}>
                {user.name}
            </div>
        </div>
    )
}

